import React from "react";
import './Body27.css';
import {Link} from "react-router-dom"
import picture381 from './source/picture381.png'
import picture382 from './source/picture382.png'
import picture383 from './source/picture383.png'
import picture384 from './source/picture384.png'
import picture385 from './source/picture385.png'
import picture386 from './source/picture386.png'
import picture387 from './source/picture387.png'






function Body27() {

  return (
    <div className="body27">
      <div className="body27-box1">
        <div className="body27-box2">
          <div className="body27-box3">Říkovice u Přerova</div>
          <div className="body27-box5"><div className="body27-box4"></div></div>
          <div className="body27-box6">
          <img className="body27-box6-picture" src={picture384} alt="picture1"/>
          <img className="body27-box6-picture" src={picture385} alt="picture1"/>
          <img className="body27-box6-picture" src={picture386} alt="picture1"/>
          <img className="body27-box6-picture2" src={picture381} alt="picture1"/>
          <img className="body27-box6-picture2" src={picture382} alt="picture1"/>
          <img className="body27-box6-picture2" src={picture383} alt="picture1"/>
          <img className="body27-box6-picture" src={picture387} alt="picture1"/>
          </div>
          <div className="body27-box8"><div className="body27-box7"><Link to="/PageProjekty">Zpět</Link></div></div>
        </div> 
      </div> 
    </div>
  );
}

export default Body27;
